import React, {createContext, useReducer} from 'react'
import { makeUserManager } from 'react-oidc'
 
const userManagerConfig = {
    client_id: 'identityaccess-spa',
    redirect_uri: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}${process.env.PUBLIC_URL}/callback`,
    response_type: 'token id_token',
    scope: 'openid profile',
    authority: `${window.location.protocol}//${window.location.hostname}${window.location.port}` + '/identityaccess.webapi',
    silent_redirect_uri: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}${process.env.PUBLIC_URL}/silent_renew`,
    post_logout_redirect_uri: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}${process.env.PUBLIC_URL}/logout`,
    automaticSilentRenew: true,
    filterProtocolClaims: false,
    loadUserInfo: true,
};

  const initialState = {
    userManager: makeUserManager(userManagerConfig),
    isLoggedIn : false
  }

  const Reducer = (state, action) => {
    switch (action.type) {
        case 'LOGGEDIN':
            return {
                ...state,
                isLoggedIn: true
            };
        case 'LOGGEDOUT':
            return {
                ...state,
                isLoggedIn: false
            };
        default:
            return state;
    }
};

  const UserContext = ({children}) => {
    const [state, dispatch] = useReducer(Reducer, initialState);
    
    return (
        <userContext.Provider value={[state, dispatch]}>
            {children}
        </userContext.Provider>
    )
};

export const userContext = createContext(initialState);
export default UserContext;